import { DeviceControlDAO } from '../../../../../../data/DeviceControlDAO';
import { commonDataAccess } from '../../data/dataAccessObject';
export const sequentialSchedulerDAO = {
    ...commonDataAccess,
    getProgrammeSetContext: DeviceControlDAO.device.control.programme.sequential.getContext,
};
